import type { SchedulingModuleConfig } from '@/types/scheduling'
import type { ApiError } from '@/components/features/bookings/bookingsUtils'

/** What an Agendamento space is born with (PROPOSTA-AGENDAMENTO section 3.3): only owner and admin offer, nothing paid. */
export const defaultSchedulingConfig = (): SchedulingModuleConfig => ({
  offerers: 'ADMINS',
  allowPaidSlots: false,
  requireListingApproval: false
})

export type SchedulingConfigErrors = Partial<Record<keyof SchedulingModuleConfig, string>>

/** `{ param: 'moduleConfig.scheduling.offerers', message }` into per-field messages. */
export const schedulingConfigApiErrors = (err: unknown): SchedulingConfigErrors | null => {
  const list = (err as ApiError | null)?.response?.data?.errors ?? []
  const out: Record<string, string> = {}
  for (const e of list) {
    const match = e.param?.match(/^moduleConfig\.scheduling\.(\w+)/)
    if (match && e.message) out[match[1]] = e.message
  }
  return Object.keys(out).length ? (out as SchedulingConfigErrors) : null
}
